/**
 * 统一管理localStorage键名，防止重复
 */

export default {
  HB_OPEN_ID: "hb_open_id",
  SDK_OPEN_ID: "sdk_open_id"
}
